import { createSelector } from 'reselect';

export const getCommissions = state => state.dashboard.statistics.commissions;

const topCommissions = commissions =>
  commissions.sort(
    (a, b) => Number(b.revenue_share_usd) - Number(a.revenue_share_usd)
  );

export const getTopCommissions = createSelector(
  getCommissions,
  topCommissions
);
